import React, {useState} from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import {orderFuncs} from '../util/Util.js';

import List from '../util/List.js'
import Confirmation from '../util/Confirmation.js'
import Client, {labeler} from './Client.js';
import {filter as clientFilter} from './ClientUtils.js';


/*
Renders a list of Clients and details of a selected Client
 */
let Clients = ({
	// data
	clients,
	client,

	// state
	action,

	// action changes
	startCreating,
	startEditing,
	cancelCreating,
	cancelEditing,
	selectClient,

	// execution
	create,
	update,
	remove,

	// analyses
	products,
	productData,
	createAnalysis,
	selectAnalysis,
	selectKairogramm,

	// questionnaire skeleton JSON
	issueQuestionnaire,
	checkForQuestionnaire,
	deleteNewestQuestionnaire,

	// info display
	showInfo,
}) => {
	const [removalConfirmation, setRemovalConfirmation] = useState();

	const actuallyRemoveClient = id => {
		remove(id);
		setRemovalConfirmation();
	};

	const handleRemoveClient = id => setRemovalConfirmation((
		<Confirmation
			title = {'Klient wirklich entfernen?'}
			actionLabel = {'Entfernen'}
			onAction = {() => actuallyRemoveClient(id)}
			cancelLabel = {'Abbrechen'}
			onCancel = {() => setRemovalConfirmation()}>
		</Confirmation>
	));

	let handleDeleteQuestionnaire;
	if (deleteNewestQuestionnaire)
		handleDeleteQuestionnaire = type => deleteNewestQuestionnaire(client.id, type);

	// render

	return (
		<Row>
			{removalConfirmation &&
			removalConfirmation
			}
			<Col className={'col-4'}>
				<List className = {'client-list'}
					title = {'Klienten'}
					addButtonTitle = {'Neuer Klient'}
					onAdd = {startCreating}
					onSelect = {selectClient}
					selected = {client}
					items = {clients}
					labeler = {labeler}
					filter = {clientFilter}
					orderFuncs = {orderFuncs}/>
			</Col>
			<Col>
				{client &&
				<Client
					key = {client.id}
					client = {client}
					action = {action}
					products = {products}
					productData = {productData}
					createAnalysis = {(date, analysis) =>
							createAnalysis(client.id, date, analysis)}
					selectAnalysis = {(type, id, part) => selectAnalysis(client.id, type, id, part)}
					selectKairogramm = {id => selectKairogramm(client.id, id)}
					issueQuestionnaire = {issueQuestionnaire}
					checkForQuestionnaire = {type => checkForQuestionnaire(client.id, type)}
					deleteNewestQuestionnaire = {handleDeleteQuestionnaire}
					startEditing = {startEditing}
					cancelCreating = {cancelCreating}
					cancelEditing = {cancelEditing}
					create = {create}
					update = {clientUpdate => update(client.id, clientUpdate)}
					remove = {handleRemoveClient}
					showInfo = {showInfo}/>
				}
			</Col>
		</Row>
	);
};

export default Clients;
